export type PersonalData = {
  fullName: string;
  currentLocation: string;
  bachelors: string;
  masters: string;
};

export const personalData = {
  fullName: "Jair Méndez",
  currentLocation: "Chicago, IL",
  bachelors: "Mechatronics Engineering",
  masters: "Information and Communications Technology Engineering",
};

export const USING_JS_SINCE: number = 2014;
export const USING_REDUX_SINCE: number = 2019;
export const USING_GOLANG_SINCE: number = 2020;
export const USING_UBUNTU_SINCE: number = 2009;
export const USING_PYTHON_SINCE: number = 2009;
